export default __webpack_public_path__ + "static/media/Authentic_successful 1.55ac852b.png";